/**
 * Версия приложения для управления кэшем и localStorage
 * 
 * ВАЖНО: Обновляйте эту версию при:
 * - Изменении структуры таблиц в БД
 * - Изменении формата данных в localStorage
 * - Добавлении/удалении полей в API ответах
 * - Критических обновлениях, требующих очистки кэша
 * 
 * Формат: MAJOR.MINOR.PATCH
 * - MAJOR: Несовместимые изменения (очистка всех данных)
 * - MINOR: Новая функциональность (выборочная очистка)
 * - PATCH: Исправления (обновление без очистки)
 */

export const APP_VERSION = '1.0.0';

/**
 * Версии API для отслеживания изменений в структуре данных
 */
export const API_VERSIONS = {
  USER_DATA: '1.0.0',        // Структура данных пользователя
  BRANCHES: '1.0.0',         // Структура филиалов
  SERVICES: '1.0.0',         // Структура услуг
  ZONES: '1.0.0',            // Структура зон
  CALENDAR: '1.0.0',         // Структура календаря
  APPOINTMENTS: '1.0.0',     // Структура записей
  CLIENTS: '1.0.0',          // Структура клиентов
  ANALYTICS: '1.0.0',        // Структура аналитики
};

/**
 * Настройки TTL (Time To Live) для различных типов данных в минутах
 */
export const CACHE_TTL = {
  USER_DATA: 60,             // 1 час
  BRANCHES: 1440,            // 24 часа
  SERVICES: 720,             // 12 часов
  ZONES: 720,                // 12 часов
  CALENDAR: 10,              // 10 минут
  APPOINTMENTS: 5,           // 5 минут
  CLIENTS: 30,               // 30 минут
  ANALYTICS: 60,             // 1 час
};
